export default "__VITE_ASSET__DeH5gdgw__"